import { useMemo } from 'react';
import InspirationSlider from '@components/InspirationSlider/InspirationSlider';
import styles from '@features/cms/components/inspirations/InspirationProductsSlider/InspirationProductsSlider.styles';
import { IInspirationProductsSlider } from '@features/cms/typescript';
import { useResponsive } from '@features/responsive';
import prepareProductsArray from '@utils/prepareProductsArray';
import theme from '@styles/theme';
import ProductCard from '@components/ProductCardNew/ProductCard';
type PropsType = {
  data: IInspirationProductsSlider;
  defaultBackground?: string;
};
const InspirationProductsSlider = ({
  data,
  defaultBackground = theme.rawColors.beige500
}: PropsType) => {
  const {
    products,
    background,
    code,
    variant
  } = data;
  const {
    isWiderThanMobilelg
  } = useResponsive();
  const prepareProducts = useMemo(() => prepareProductsArray(products), [products]);
  return isWiderThanMobilelg ? <div id={code} sx={styles.sliderContainer(background || defaultBackground)}>
      <InspirationSlider withScrollBar equalHeightSlides spaceBetween={24} slidesPerView="auto" withOffset>
        {prepareProducts.map(product => <div sx={styles.productBox(variant === 'big')} key={product.id}>
            <ProductCard product={product} isSmall={variant !== 'big'} isSlider />
          </div>)}
      </InspirationSlider>
    </div> : <div sx={styles.container(background || defaultBackground)} data-testid="inspiration-products-slider">
      {prepareProducts.slice(0, 6).map(product => <div sx={styles.productBox(false)} key={product.id} data-testid="inspiration-products-slider-product">
          <ProductCard product={product} isSmall />
        </div>)}
    </div>;
};
export default InspirationProductsSlider;